<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left"> Сообщения</h4>
                    </div>
                    <div class="card-body table-responsive">
                        <table class="table table-hover message-list">
                            <thead>
                                <tr>
                                    <th width="5%"></th>
                                    <th width="20%">Имя</th>
                                    <th width="10%">E-Mail</th>
                                    <th width="10%">Телефон</th>
                                    <th width="20%">Тема</th>
                                    <th width="25%">Сообщение</th>
                                    <th width="10%" class="d-none d-md-table-cell">Дата</th>
                                    <!-- <th></th> -->
                                </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                                <tr v-for="result in results.data" :key="result.id" :class="{'unread': !result.completed}">
                                    <td>
                                        <div class="form-check pl-0">
                                            <label class="form-check-label">
                                                <input class="form-check-input" type="checkbox" v-model="result.completed" @change="onStatusChange(result)">
                                                <span class="form-check-sign"></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td>{{result.name}}</td>
                                    <td>{{result.email}}</td>
                                    <td>{{result.phone}}</td>
                                    <td>{{result.title}}</td>
                                    <td>{{result.message}}</td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.createdDate">{{result.createdDate}}</div>
                                    </td>
                                    <!-- <td>
                                        <div class="btn-group btn-group-sm">
                                            <router-link :to="'/region/view/' + result.id" tag="button" class="btn btn-info">
                                                <i class="fa fa-eye"></i>
                                            </router-link>
                                        </div>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">Нет данных</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.pageCount && results.pageCount > 1 ">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page" :per-page="filter.pageSize" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import {BPagination} from 'bootstrap-vue';
    import FilterModel from './../../shared/filter';

    export default {
        name: "MessageList",
        components: {
            'b-pagination': BPagination
        },
        data() {
            return {
                loading: false,
                filter: new FilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.get('message', this.filter.asQuery())
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page = page;
                this.initList();
            },
            onStatusChange(message) {
                this.$http.post('message/status', {
                    id: message.id,
                    completed: message.completed
                }).then(() => {});
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style>
    .message-list .unread td {
        font-weight: bold;
    }
</style>